import { configureStore } from '@reduxjs/toolkit';

import cartSliceReducer from './slices/cartSlice';

import { apiSlice } from './slices/apiSlice';

import authSliceReducer from './slices/authSlice';

const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    cart: cartSliceReducer,
    auth: authSliceReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
});

export default store;
